export default "__VITE_ASSET__57e0c672__"